import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { bonuses } from '../../data/bonuses';
import { padNumber } from '../../utils/format';
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-forest py-20 text-white lg:py-24" data-id="element-17" data-mp="1nan0e5qaye35">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-18" data-mp="1s8ojgqnqadem">
        <SectionHeading id="bonuses-title" eyebrow="5 bonuses included" lead="Plus 5" highlight="teaching resources" intro="Practical extras that sit beside the main guide. All five come with your $27 pack." data-id="element-19" data-mp="1dd8nuh7i29g4" />

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-20" data-mp="14edc6plos75f">
          {bonuses.map((bonus, index) => <li key={bonus.name} className={`flex flex-col overflow-hidden rounded-xl border border-white/15 bg-pine ${index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-12px)]' : ''}`} data-id="element-21" data-mp="19d87gr0ubo6f" data-mpi={index}>
              <div className="bg-cream p-5 sm:p-6" data-id="element-22" data-mp="fzn91qm230tm">
                <img src={bonus.image} alt={`${bonus.name} cover`} loading="lazy" className="mx-auto block aspect-square h-auto w-full max-w-[340px] object-contain" data-id="element-23" data-mp="c0o5a9c29a3r" />
              </div>
              <div className="flex-1 border-t border-white/15 p-6 sm:p-7" data-id="element-24" data-mp="3t801yz3c91dw">
                <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-25" data-mp="3ta2p9bd3wgex">Bonus {padNumber(index + 1)}</p>
                <h3 className="mt-2 font-display text-[28px] font-bold uppercase leading-[1.02] sm:text-[30px]" data-id="element-26" data-mp="70s1aa3d5io7">{bonus.name}</h3>
                <p className="mt-2 text-base leading-relaxed text-white/80" data-id="element-27" data-mp="21fchjsxm1iz">{bonus.benefit}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-28" data-mp="1ihrqgwuezhe0">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-29" data-mp="1dhnbxcd2gwqf">
            Get the lesson pack
          </CtaButton>
        </div>
      </div>
    </section>;
}